import { ContactForm } from '@/components/ui';
import React from 'react';

export const MobilePortfolioContact: React.FC = () => {
    return <ContactForm variant='component' />;
};
